// Parent layout for /circles/$id/admin/*. Owns the leader-or-admin auth
// gate; children (index, broadcasts/new) mount inside the Outlet so they
// share the same gate without re-implementing it.

import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { requireLeaderOrAdmin } from '@/lib/route-guards';

export const Route = createFileRoute('/_authed/circles/$id/admin')({
  beforeLoad: async ({ context, params }) => {
    await requireLeaderOrAdmin(context, {
      groupId: params.id,
      bounceTo: () =>
        redirect({ to: '/circles/$id', params: { id: params.id } }),
    });
  },
  component: Outlet,
});
